// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

// zhLocale.table = {
//     emptyText: '暂无数据',
//     confirmFilter: '筛选',
//     resetFilter: '全(不)选',
//     clearFilter: '全部',
//     sumText: '合计'
// };

export default {
    page: {
        other: {
            login: {
                title: window.__is_admin ? "游戏后台管理系统" : "通路管理系統",
                forgetPwd: "找回密码？",
                alert: {
                    failed: "用户名或密码错误",
                    count: "第{errorCount}次",
                    note: "5次输入错误用户将锁定",
                    lockTip: "此帐号已冻结",
                    str: ["请联络", "或"],
                    link: ["客服人员", "申请解锁"],
                    pMode: "系统维护中",
                },
            },
            forgetPwd: {
                title: "忘记密码",
            },
            restoreAccount: {
                title: "申请解锁",
            },
        },
    },
    component: {
        dropdown: {
            areaCode: "请选择区码",
        },
        form: {
            input: {
                placeholder: {
                    username: "用户名",
                    mobile: "请输入移动电话",
                    graphicValidation: "请输入图形验证",
                },
            },
        },
        btn: {
            login: "登录",
            confirm: '确认',
        },
        label: {
            rememberMe: "记住我"
        },
        dialog: {
            title: "操作提示"
        },
    },
    column: {
        password: "密码",
        input_username: "输入帐号",
        mobile: "移动电话",
        graphicValidation: "图形验证",
    },
    // ...zhLocale,
};
